import { useModal } from 'modals';

import Text from '@cartwhl/ui/base/Text';
import GoButton from '@cartwhl/ui/input/GoButton';

export default function EnterpriseCard() {
  const { open } = useModal();

  return (
    <div className="border-green-35 bg-green-35/10 relative flex w-full flex-none flex-col flex-nowrap justify-between rounded-2xl border px-4 py-6 sm:flex-row md:min-h-[390px] md:flex-1 md:flex-col xl:px-6 xl:py-7">
      <div>
        <Text
          as="h2"
          variant="web/display/lg"
          className="flex items-center gap-2"
        >
          <div className="bg-green-35 inline-block h-4 w-4 rounded-full" />
          Enterprise
        </Text>
        <div className="grow pt-6">
          <Text
            as="p"
            variant="web/body/medium/md"
            className="text-gray-60 dark:text-gray-45 max-w-[245px]"
          >
            For organizations who operate with unique pipelines, require custom
            control, and have specific security needs.
          </Text>
        </div>
      </div>
      <div className="flex flex-col pt-8 sm:pt-0 md:mt-auto md:pt-8">
        <GoButton
          variant="animate"
          className="min-w-[191px]"
          onClick={() => open('ENTERPRISE_CONTACT', { reason: 'pricing_plans' })}
        >
          Contact us
        </GoButton>
      </div>
    </div>
  );
}
